export const teamData = [
  {
    id: 1,
    image: './images/amit-sir.webp',
    content: `Mr. Amit Jain is a SEBI registered stock market research analyst, a man with magical figures. He's a best stock market psychiatrist as a research analyst he collects data, analyzes trends and forecasts and makes recommendations to you for better optimization for your trading and investments.`,
  },
  {
    id: 2,
    image: './images/ankush-sir.webp',
    content: `Ankush Jain's dual expertise as a Chartered Accountant and SEBI Research Analyst positions him as a valuable asset in the financial industry and to our organization. His commitment to excellence, coupled with a deep understanding of financial principles and market dynamics, makes him a trusted advisor for businesses and investors alike.`,
  },
  {
    id: 3,
    image: './images/atul-sir.webp',
    content: `Atul Jain as a Customer Support and Client Relations Specialist underscores his significance in maintaining strong client relationships, driving sales, and elevating the overall customer experience. His skills in team leadership, client engagement, and sales contribute significantly to the company's success.`,
  },
  {
    id: 4,
    image: './images/shahid-sir.webp',
    content: `Shahid Parek's mentorship is a driving force behind our company's success. His insights, leadership, and commitment to excellence make him an invaluable contributor to our mission of achieving sustained growth and success in the marketplace.`,
  },
  {
    id: 5,
    image: './images/intelisys-team.webp',
    content: `The positive growth experienced by Intelisys Ventures Limited is a direct result of the collective efforts of its exceptional team. From visionary leadership to innovative solutions and client-centric practices, each team member plays a crucial role in driving the organization forward. As we continue to grow, the dedication and expertise of the Intelisys Ventures team remain instrumental in shaping a successful and sustainable future for the organization.`,
  },
];

export const returnData = [
  {
    id: 1,
    image: './images/300-returns.webp',
    content: `The exceptional achievement of a 300% return on investment in just three years for clients of Intelisys. Intelisys not only provides strategic advisory services but also goes above and beyond to ensure that clients' financial objectives are not only met but exceeded.`,
  },
  {
    id: 2,
    image: './images/mcx-returns.webp',
    content: `Intelisys Ventures Private Limited had achieved an extraordinary yearly return on investment (ROI) of 848.97% in the Multi Commodity Exchange (MCX) market (crude oil, natural gas, gold, silver, copper, zinc). This Remarkable success happened because intelisys believes in collecting data, analyzing trends and forecasts and makes recommendations accordingly for our clients for better optimization for their trading.`,
  },
  {
    id: 3,
    image: './images/bramhastra-returns.webp',
    content: `Intelisys Ventures is thrilled to share the outstanding success of its Bramhastra Plan, introduced in 2021. This visionary trading strategy has delivered an impressive return on investment (ROI) of 169.32% to our esteemed clients, showcasing the plan's efficacy and our commitment to financial excellence.`,
  },
  {
    id: 4,
    image: './images/mahabahubali-returns.webp',
    content: `The Mahabahubali Plan's robust ROI of 163.97% has had a profound impact on our clients. It has not only met their expectations but has exceeded them, solidifying Intelisys Ventures Private limited as a reliable partner in wealth creation.`,
  },
];

export const eventData = [
  {
    id: 1,
    image: './images/event-1.webp',
    content: `Intelisys Ventures Private Limited India’s 1st Discounted SEBI Registered advisory is delighted to announce its prestigious recognition by Business Connect, one of India's foremost business magazines, as a standout organization led by young entrepreneurs. This acknowledgment underscores our commitment to innovation, excellence, and its significant contributions to the business.`,
  },
  {
    id: 2,
    image: './images/brand-empowerment.webp',
    content: `Intelisys Ventures Private Limited has been honored with the prestigious recognition at the Brand Empower Industry Leaders Awards & Convention 2023. Intelisys has been awarded the title of the "Best Stock and Commodity Analysis Market Company." This achievement reflects the company's commitment to excellence and positions it as a trailblazer in the dynamic landscape of market analysis.`,
  },
];
